import React, { Component } from 'react';
import * as d3 from 'd3';

import ChartSpecs from '../data/chart_specs';

var svgWidth = window.innerWidth,
    svgHeight = window.innerHeight,
    mobileBreakpoint = 768,
    radius = 22,
    goodlookingScores = {1:"Very Strange Looking", 2:"Slightly Strange Looking", 3:"Average Looking",4:"Good Looking",5:"Very Good Looking"},
    greetings = {"Cranky":"Heya", "Jock":"Yo","Lazy":"Hi","Normal":"Hi there","Peppy":"Hiya","Sisterly":"Oh hey","Smug":"Hey","Snooty":"Hello"},
    margin = {
      top: 16,
      right: 32,
      bottom: 300,
      left: 32,
    };

const personalities = Object.keys(ChartSpecs.chartspecs.colorWheelObjPersonality).sort((a,b)=>a.localeCompare(b));
const hobbies = Object.keys(ChartSpecs.chartspecs.colorWheelObjHobby).sort((a,b)=>a.localeCompare(b));
const skinColorWheelObj = ChartSpecs.chartspecs.colorWheelObjRainbow;
const brightness = Object.keys(ChartSpecs.chartspecs.colorWheelObjBrightness);
const skincolorSegment = Object.keys(ChartSpecs.chartspecs.colorWheelObjRainbow);
const acnhicons = ["leaf"];
const acnhiclip = ["half-moon"];
const species = ChartSpecs.species;
const starsigns = Object.keys(ChartSpecs.chartspecs.colorWheelObjStar);
const acnhColors = ChartSpecs.chartspecs.acnhColors;

class TopVillagersChart extends Component {
  constructor(props){
      super(props);
      this.svgRef = React.createRef();
      this.state = {
        currentStep:this.props.currentStep,
        chartWidth:this.props.chartWidth,
        chartHeight:this.props.chartHeight,
        isChartOn:false,
      };

      this.flattenVillagers = this.props.villagers;
      let topVillagerBase = Math.round(this.flattenVillagers.length/10); //40

      this.simulation = d3.forceSimulation(this.flattenVillagers);

      this.topVillagers = this.flattenVillagers.filter(v => v.Average_Popularity_Ranking <= topVillagerBase);

      this.topVillagerNodes = {};
      this.topVillagerPersonalityNodes = {};
      this.topVillagerSpeciesNodes = {};
      this.topVillagerHobbyNodes = {};
      this.topVillagerStarSignNodes = {};
      this.topVillagerAppearanceNodes = {};
      this.topVillagerSkincolorNodes = {};

      this.toggleChart = this.toggleChart.bind(this);

   }

   componentDidMount() {
     this.svg = d3.select(this.svgRef.current);
     this.setUpVillagerThumbnail();
     this.drawForceChart();
     this.updateChart(this.props.currentStep);
   }

    componentDidUpdate(prevProps) {
      if (this.props.currentStep !==  prevProps.currentStep || this.props.chartWidth !==  prevProps.chartWidth) {
        this.setState({
         currentStep: this.props.currentStep,
         chartHeight: this.props.chartHeight,
         chartWidth: this.props.chartWidth
        });
        this.updateChart(this.props.currentStep);
      }
      //this.drawForceChart();
    }


  setUpVillagerThumbnail(){
    //// Create defs elements //////
    //var defs = this.svg.append("defs");
    var defs = d3.select('#svg-patterns');
    //Create wrapper for the clip paths
    var imageWrapper = defs.append("g").attr("class", "image-group-wrapper");
    let flattenVillagers = this.flattenVillagers,
        totalVillagerNumber = flattenVillagers.length,
        radiusBase = 25,
        topVillagers = this.topVillagers;

     //Create a circle with an image for villagers
     let defaultImageWrapper = imageWrapper.selectAll(".villager-thumbnail-image")
       .data(topVillagers)
       .join("pattern")
       .attr("id", d => `villager-thumbnail-${d.name}`)
       .attr("class", "thumbnail-image villager-thumbnail-image")
       //.attr("viewBox", `-${radius*0.05} -${radius*0} ${radius} ${radius}`)
       .attr("viewBox", `-${radiusBase*0.05} -${radiusBase*0} ${radiusBase} ${radiusBase}`)
       .attr("height", "100%")
       .attr("width", "100%")
       .attr('patternContentUnits', 'objectBoundingBox')

       defaultImageWrapper.append("path")
         .attr("class", "def-villager-bg")
         .attr("id", d => `def-villager-bg-${d.name}`)
         .attr("fill-opacity", 0.3)
         .attr("fill", acnhColors.themeColor)
         .style("stroke", "transparent")
         .attr("d", "M11.6325 0.892493C11.9169 0.581302 12.4251 0.652726 12.6127 1.03025L15.4596 6.75915C15.521 6.88274 15.6231 6.98138 15.7488 7.03844L21.5736 9.68368C21.9574 9.858 22.0465 10.3634 21.7454 10.6585L17.1767 15.1364C17.0781 15.233 17.0159 15.3606 17.0004 15.4978L16.2846 21.8549C16.2374 22.2738 15.7843 22.5147 15.4106 22.3196L9.74006 19.3582C9.61773 19.2943 9.47712 19.2745 9.34192 19.3022L3.07475 20.5859C2.66175 20.6705 2.29259 20.314 2.36271 19.8983L3.42688 13.5901C3.44983 13.454 3.42518 13.3142 3.35706 13.1942L0.19956 7.63042C-0.00851521 7.26377 0.216456 6.80251 0.63348 6.74075L6.96173 5.8035C7.09825 5.78328 7.22362 5.71662 7.31672 5.61475L11.6325 0.892493Z")
         //.attr("transform", `scale(0.9) translate(${radius*0.05},${radius*0.05})`)
         .attr("transform", `scale(${1}) translate(0,0)`)

        defaultImageWrapper
         .append("image")
         //.attr("xlink:href", d => d.image_url)
         .attr("xlink:href", function(d,i) {
           return process.env.PUBLIC_URL + `/images/face/face-image-${d.id}.png`
           //return require(`../images/${d}.png`)
         })
         .attr('preserveAspectRatio', 'xMidYMid meet')
         .attr("transform", `translate(${radius*0.08},${radius*0.1})`)
         .attr("height", radius*0.8)
         .attr("width", radius*0.8);


       //Create a circle with an image for unique villagers
       let specialImageWrapper = imageWrapper.selectAll(".villager-thumbnail-s-image")
         .data(topVillagers)
         .join("pattern")
         .attr("id", d => `villager-thumbnail-s-${d.name}`)
         .attr("class", "thumbnail-image villager-thumbnail-image")
         //.attr("viewBox", `-${radius*0.05} -${radius*0} ${radius} ${radius}`)
         .attr("viewBox", `-${radiusBase*0.05} -${radiusBase*0} ${radiusBase} ${radiusBase}`)
         .attr("height", "100%")
         .attr("width", "100%")
         .attr('patternContentUnits', 'objectBoundingBox')


         specialImageWrapper.append("path")
           .attr("class", "def-villager-bg bg-special")
           .attr("id", d => `def-villager-s-bg-${d.name}`)
           .attr("fill-opacity", 0.6)
           .attr("fill", acnhColors.bgPinkColor)
           .style("stroke", "transparent")
           .attr("d", "M11.6325 0.892493C11.9169 0.581302 12.4251 0.652726 12.6127 1.03025L15.4596 6.75915C15.521 6.88274 15.6231 6.98138 15.7488 7.03844L21.5736 9.68368C21.9574 9.858 22.0465 10.3634 21.7454 10.6585L17.1767 15.1364C17.0781 15.233 17.0159 15.3606 17.0004 15.4978L16.2846 21.8549C16.2374 22.2738 15.7843 22.5147 15.4106 22.3196L9.74006 19.3582C9.61773 19.2943 9.47712 19.2745 9.34192 19.3022L3.07475 20.5859C2.66175 20.6705 2.29259 20.314 2.36271 19.8983L3.42688 13.5901C3.44983 13.454 3.42518 13.3142 3.35706 13.1942L0.19956 7.63042C-0.00851521 7.26377 0.216456 6.80251 0.63348 6.74075L6.96173 5.8035C7.09825 5.78328 7.22362 5.71662 7.31672 5.61475L11.6325 0.892493Z")
           //.attr("transform", `scale(0.9) translate(${radius*0.05},${radius*0.05})`)
           .attr("transform", `scale(${1}) translate(0,0)`)

          specialImageWrapper
           .append("image")
           //.attr("xlink:href", d => d.image_url)
           .attr("xlink:href", function(d,i) {
             return process.env.PUBLIC_URL + `/images/face/face-image-${d.id}.png`
             //return require(`../images/${d}.png`)
           })
           .attr('preserveAspectRatio', 'xMidYMid meet')
           .attr("transform", `translate(${radius*0.08},${radius*0.1})`)
           .attr("height", radius*0.8)
           .attr("width", radius*0.8);

           //Create a circle with an image for villagers
           let houseImageWrapper = imageWrapper.selectAll(".villager-house-thumbnail-image")
             .data(topVillagers)
             .join("pattern")
             .attr("id", d => `villager-house-thumbnail-${d.name}`)
             .attr("class", "thumbnail-image villager-house-thumbnail-image")
             .attr("viewBox", `-${radiusBase*0.05} -${radiusBase*0} ${radiusBase} ${radiusBase}`)
             .attr("height", "100%")
             .attr("width", "100%")
             .attr('patternContentUnits', 'objectBoundingBox')

             houseImageWrapper.append("path")
               .attr("class", "def-house-bg")
               .attr("id", d => `def-house-bg-${d.name}`)
               .attr("fill-opacity", 0.3)
               .attr("fill", acnhColors.themeColor)
               .style("stroke", "transparent")
               .attr("d", "M13.0764 0.987642C15.4494 1.19526 24.5553 11.9338 23.6059 11.8507C22.6564 11.7677 20.2525 11.5574 20.2525 11.5574L19.5394 19.7076C19.5154 19.9826 19.2729 20.1861 18.9978 20.1621L11.4566 19.5023L3.91536 18.8425C3.64027 18.8185 3.43678 18.576 3.46084 18.3009L4.17389 10.1507C4.17389 10.1507 1.76992 9.94034 0.820457 9.85728C-0.129003 9.77421 10.7033 0.780028 13.0764 0.987642Z")
               //.attr("transform", `scale(0.9) translate(${radius*0.05},${radius*0.05})`)
               .attr("transform", `scale(${1}) translate(-${radius*0.05}, ${radius*0.05})`)

              houseImageWrapper
               .append("image")
               //.attr("xlink:href", d => d.image_url)
               .attr("xlink:href", function(d,i) {
                 return process.env.PUBLIC_URL + `/images/face/face-image-${d.id}.png`
                 //return require(`../images/${d}.png`)
               })
               .attr('preserveAspectRatio', 'xMidYMid meet')
               .attr("transform", `translate(${radius*0.1},${radius*0.1})`)
               .attr("height", radius*0.8)
               .attr("width", radius*0.8);

           //Create a circle with an image for villagers
           let specialHouseImageWrapper = imageWrapper.selectAll(".villager-s-house-thumbnail-image")
             .data(topVillagers)
             .join("pattern")
             .attr("id", d => `villager-s-house-thumbnail-${d.name}`)
             .attr("class", "thumbnail-image villager-s-house-thumbnail-image")
             .attr("viewBox", `-${radiusBase*0.05} -${radiusBase*0} ${radiusBase} ${radiusBase}`)
             .attr("height", "100%")
             .attr("width", "100%")
             .attr('patternContentUnits', 'objectBoundingBox')

             specialHouseImageWrapper .append("path")
               .attr("class", "def-s-house-bg")
               .attr("id", d => `def-s-house-bg-${d.name}`)
               .attr("fill-opacity", 0.8)
               .attr("fill", acnhColors.bgPinkColor)
               .style("stroke", acnhColors.borderYellowColor)
               .style("stroke-width", 1.5)
               .attr("d", "M13.0764 0.987642C15.4494 1.19526 24.5553 11.9338 23.6059 11.8507C22.6564 11.7677 20.2525 11.5574 20.2525 11.5574L19.5394 19.7076C19.5154 19.9826 19.2729 20.1861 18.9978 20.1621L11.4566 19.5023L3.91536 18.8425C3.64027 18.8185 3.43678 18.576 3.46084 18.3009L4.17389 10.1507C4.17389 10.1507 1.76992 9.94034 0.820457 9.85728C-0.129003 9.77421 10.7033 0.780028 13.0764 0.987642Z")
               //.attr("transform", `scale(0.9) translate(${radius*0.05},${radius*0.05})`)
               .attr("transform", `scale(${1}) translate(-${radius*0.05}, ${radius*0.05})`)

              specialHouseImageWrapper
               .append("image")
               //.attr("xlink:href", d => d.image_url)
               .attr("xlink:href", function(d,i) {
                 return process.env.PUBLIC_URL + `/images/face/face-image-${d.id}.png`
                 //return require(`../images/${d}.png`)
               })
               .attr('preserveAspectRatio', 'xMidYMid meet')
               .attr("transform", `translate(${radius*0.1},${radius*0.1})`)
               .attr("height", radius*0.8)
               .attr("width", radius*0.8);



         //Create a circle with an image for each personality
         imageWrapper.selectAll(".personality-thumbnail-image")
           .data(personalities)
           .join("pattern")
           .attr("id", d => `villager-personality-${d}`)
           .attr("class", "thumbnail-image personality-thumbnail-image")
           //.attr("patternUnits", "objectBoundingBox")
           .attr("height", "100%")
           .attr("width", "100%")
           .attr('patternContentUnits', 'objectBoundingBox')
           .append("image")
             .attr("xlink:href", function(d,i) {
               return process.env.PUBLIC_URL + `/images/personality/${d}.png`
               //return require(`../images/${d}.png`)
             })
             .attr('preserveAspectRatio', 'xMidYMin slice')
             .attr("height", 1)
             .attr("width", 1);

         //Create a circle with an image for each species
         var speciesImgWrapper = imageWrapper.selectAll(".species-thumbnail-image")
           .data(species)
           .join("pattern")
           .attr("id", function(d,i) {
             if(d.indexOf(' ') >= 0){
                  d = d.replace(/ /g,"-")
              }
              if(d === 'Cow' || d === 'Bull'){
                d = 'Bovine'
              }
             return `villager-species-${d}`
           })
           .attr("class", "thumbnail-image species-thumbnail-image")
           //.attr("patternUnits", "objectBoundingBox")
           .attr("height", "100%")
           .attr("width", "100%")
           .attr('patternContentUnits', 'objectBoundingBox');


        speciesImgWrapper.append("circle")
        .attr("class", "species-bg")
        .style("fill", acnhColors.themeColor)
        .attr("r", function(d,i) {
          var smallSize = i >= totalVillagerNumber ? 0.5 : 1;
          return 2*radius*smallSize*1 * 5;
        })

        speciesImgWrapper.append("image")
        .attr("xlink:href", function(d,i) {
          if(d.indexOf(' ') >= 0){
               d = d.replace(/ /g,"-")
           }
           if(d === 'Cow' || d === 'Bull'){
             d = 'Bovine'
           }
          return process.env.PUBLIC_URL + `/images/species/${d}.png`
          //return require(`../images/${d}.png`)
        })
        .attr('preserveAspectRatio', 'xMidYMin slice')
        .attr("height", 1)
        .attr("width", 1);

       //Create a circle with an image for each Star Sign
       var starsignImgWrapper = imageWrapper.selectAll(".starsign-thumbnail-image")
         .data(starsigns)
         .join("pattern")
         .attr("id", d => `villager-starsign-${d}`)
         .attr("class", "thumbnail-image starsign-thumbnail-image")
         //.attr("patternUnits", "objectBoundingBox")
         .attr("height", "100%")
         .attr("width", "100%")
         .attr('patternContentUnits', 'objectBoundingBox')
         .append("image")
           .attr("xlink:href", function(d,i) {
             return process.env.PUBLIC_URL + `/images/zodiac/${d}.png`
             //return require(`../images/${d}.png`)
           })
           .attr('preserveAspectRatio', 'xMidYMin slice')
           .attr("transform", `translate(${0.15},${0.15})`)
           .attr("height", 0.7)
           .attr("width", 0.7);

       //create half moon:
        var halfMoonWrapper =imageWrapper.selectAll(".half-moon")
        .data(acnhiclip)
        .join("clipPath")
        .attr("id", "half-moon")
        .attr("class", "half-moon")
        .attr("height", "100%")
        .attr("width", "100%")
        .attr('clipPathUnits', 'objectBoundingBox')

        halfMoonWrapper.append("rect")
        .attr("x", 0)
        .attr("y", 0)
        .attr("height", radius/2)
        .attr("width", radius);

        //Create a circle with an image for leafIcon
        var leafIconWrapper = imageWrapper.selectAll(".acnh-icon")
        .data(acnhicons)
        .join('pattern')
        .attr("id", d => `icon-${d}`)
        .attr("class", "thumbnail-image acnh-icon")
        .attr("height", "100%")
        .attr("width", "100%")
        .attr('patternUnits', 'objectBoundingBox')

        leafIconWrapper.append("image")
        .attr("xlink:href", d => process.env.PUBLIC_URL + `/images/${d}.svg`)
        .attr('preserveAspectRatio', 'xMidYMid slice')
        .attr("height", radius/2)
        .attr("width", radius/2);

  }


   drawForceChart(){
     // init plot
     this.simulation.stop();

     let svg = this.svg,
          skinColors =  this.props.villagerSkinColors,
          textColors =  this.props.villagerTextColors,
          topVillagers = this.topVillagers;


    svg.append("g").classed('villager-label-container', true)

    let svgVillagerNode = svg.selectAll('.node'),
        tooltipPhrase2 = d3.select('#tooltip-phrase2');



    let tooltipPhrase  = d3.select("body").append("div")
                            .attr("id", "tooltip-phrase");

    svgVillagerNode.data(topVillagers)
        .join("circle")
        .classed('node', true)
        //.transition().duration(300)
        .attr("name", d => d.name)
        //.style("fill", d => skinColors.get(d.id))
        .style("stroke-width", 2)
        .attr("r", radius)


    /*svg.selectAll('.villager-label')
        	.data(topVillagers)
          .join("g")
          .classed('villager-label', true)*/

      this.simulation.on('tick', function() {
               svg.selectAll('.node')
               	  .attr('cx', function(d) { return d.x; })
               	  .attr('cy', function(d) { return d.y; })
                //.attr("transform", function(d) { return "translate(" + (d.x) + "," + (d.y) + ")"; })
            })
      this.simulation.nodes(topVillagers)
       .alpha(1)
       .restart();

   }

   updateChart(step){
    this.svg.selectAll(".villager-label").remove();
    this.svg.selectAll(".villager-label-unique").remove();
    this.svg.selectAll(".hull-path").remove();

     var topVillagers = this.topVillagers,
         skinColors =  this.props.villagerSkinColors,
         textColors =  this.props.villagerTextColors,
         chartWidth = this.props.chartWidth;

     /* set up mutiple colli  */
     let basePerRow = 8
     if( window.innerWidth <= mobileBreakpoint){
       basePerRow = 5;
     }
     let baseRowWidth = (chartWidth + 0) / (basePerRow + 1);
     let baseRowHeight = (baseRowWidth > (radius*3.5))? radius*3.5 : baseRowWidth;

     if( window.innerWidth <= mobileBreakpoint){
       baseRowHeight = radius*2;
     }

     // Summary Node Position
     this.topVillagerNodes = topVillagers.sort((a,b)=>a.Average_Popularity_Ranking-b.Average_Popularity_Ranking).reduce((obj, villager, i) => {
        let uniqueCount = Object.keys(obj).length,
            positionX = (uniqueCount % basePerRow + 1) * baseRowWidth,
            positionY = (Math.floor(uniqueCount / basePerRow) + 0.5) * baseRowHeight;
         obj[villager.name] = {
           id: i+1,
           name: villager.name,
           label: villager.name,
           x: positionX,
           y: positionY + radius * 1.5 * (Math.floor(uniqueCount / basePerRow) + 0.5),
         };
        uniqueCount++
        return obj;
      }, {});

      // Personality Node Position
      let personalityPerRow = 4;

      if( window.innerWidth <= mobileBreakpoint){
        personalityPerRow = 3;
      }

      let personalityRowWidth = chartWidth / (personalityPerRow + 1),
          sortByPersonality = personalities;

      this.topVillagerPersonalityNodes = topVillagers.sort((a,b)=> sortByPersonality.indexOf(a.personality) - sortByPersonality.indexOf(b.personality)).reduce((obj, villager, i) => {
          let uniqueCount = Object.keys(obj).length;
          if (obj[villager.personality]){
              ++obj[villager.personality].count;
          } else {
            obj[villager.personality] = {
              id: i+1,
              label: villager.personality,
              count: 1,
              x: (uniqueCount % personalityPerRow + 1) * personalityRowWidth,
              y: (Math.floor(uniqueCount / personalityPerRow) + 1) * personalityRowWidth + (Math.floor(uniqueCount / personalityPerRow) - 0.1)*personalityRowWidth,
            };
            uniqueCount++
          }
         return obj;
       }, {});


       // Species Node Position
       let speciesPerRow = 4,
           speciesY = 0.7,
           speciesRowPadding = 0,
           speciesRowWidth = chartWidth / (speciesPerRow + 1);


       if( window.innerWidth <= mobileBreakpoint){
         speciesPerRow = 4;
         speciesY = 1.1;
         speciesRowPadding = radius*6;
         speciesRowWidth = chartWidth / (speciesPerRow + 1);
       }

       this.topVillagerSpeciesNodes = topVillagers.sort((a,b)=>a.species.localeCompare(b.species)).reduce((obj, villager, i) => {
           let uniqueCount = Object.keys(obj).length;
           if (obj[villager.species]){
               ++obj[villager.species].count;
           } else {
             obj[villager.species] = {
               id: i+1,
               label: villager.species,
               count: 1,
               x: (uniqueCount % speciesPerRow + 1) * speciesRowWidth,
               //y: (Math.floor(uniqueCount / speciesPerRow) + speciesY) * speciesRowWidth,
               y: (Math.floor(uniqueCount / speciesPerRow) + speciesY) * speciesRowWidth + (Math.floor(uniqueCount / speciesPerRow) - 0.1)*speciesRowPadding/2,
             };
             uniqueCount++
           }
          return obj;
        }, {});


      let starsignPerRow = 4,
          starsignY = 0.7,
          starsignRowPadding = radius*1,
          starsignRowWidth = chartWidth / (starsignPerRow + 1),
          sortByStarSign = starsigns;

      if( window.innerWidth <= mobileBreakpoint){
          starsignPerRow = 3;
          starsignRowWidth = chartWidth / (speciesPerRow + 0);
          starsignRowPadding = radius*6;
          starsignY = 0.8;
      }


      this.topVillagerStarSignNodes = topVillagers.sort((a,b)=> sortByStarSign.indexOf(a.sign) - sortByStarSign.indexOf(b.sign)).reduce((obj, villager, i) => {
            let uniqueCount = Object.keys(obj).length;
            if (obj[villager.sign]){
                ++obj[villager.sign].count;
            } else {
              obj[villager.sign] = {
                id: i+1,
                label: villager.sign,
                count: 1,
                x: (uniqueCount % starsignPerRow + 1) * starsignRowWidth,
                y: (Math.floor(uniqueCount / starsignPerRow) + starsignY) * starsignRowWidth + (Math.floor(uniqueCount / starsignPerRow) - 0.1)*starsignRowPadding/2,
              };
              uniqueCount++
            }
           return obj;
         }, {});


       // Hobby Node Position
       let hobbyPerRow = 3,
           hobbyRowWidth = chartWidth / (hobbyPerRow + 1),
           hobbyRowPadding = chartWidth / (hobbyPerRow + 0),
           hobbyY = 0.7,
           sortByHobby = hobbies;

       if( window.innerWidth <= mobileBreakpoint){
         hobbyPerRow = 2;
         hobbyY = 0.35;
         hobbyRowPadding = radius*10;
         hobbyRowWidth = chartWidth / (hobbyPerRow + 1);
       }

       this.topVillagerHobbyNodes = topVillagers.sort((a,b)=> sortByHobby.indexOf(a.hobby) - sortByHobby.indexOf(b.hobby)).reduce((obj, villager, i) => {
           let uniqueCount = Object.keys(obj).length;
           if (obj[villager.hobby]){
               ++obj[villager.hobby].count;
           } else {
             obj[villager.hobby] = {
               id: i+1,
               label: villager.hobby,
               count: 1,
               x: (uniqueCount % hobbyPerRow + 1) * hobbyRowWidth,
               y: (Math.floor(uniqueCount / hobbyPerRow) + hobbyY) * hobbyRowPadding,
             };
             uniqueCount++
           }
          return obj;
        }, {});


       // Skincolor Node Position
       let skincolorPerRow = 3,
           skincolorRowWidth = chartWidth / (skincolorPerRow + 1),
           skincolorRowPadding = chartWidth / (skincolorPerRow + 0),
           skincolorTopSpace = 0,
           skincolorY = 0.7,
           sortBySkinColor = skincolorSegment;

       if( window.innerWidth <= mobileBreakpoint){
         skincolorPerRow = 2;
         skincolorRowWidth = chartWidth / (skincolorPerRow + 0.5);
         skincolorRowPadding = (skincolorRowWidth > (radius*10))? skincolorRowWidth : radius*10;
         skincolorTopSpace = radius*6;
         skincolorY = 1.1;
       }

       this.topVillagerSkincolorNodes = topVillagers.sort((a,b)=> sortBySkinColor.indexOf(a.colorSegment) - sortBySkinColor.indexOf(b.colorSegment)).reduce((obj, villager, i) => {
           let uniqueCount = Object.keys(obj).length;
           if (obj[villager.colorSegment]){
               ++obj[villager.colorSegment].count;
           } else {

                //adjust height of last group, aka blue
                let itemRow = Math.floor(uniqueCount / skincolorPerRow) + 1;

                if(itemRow === 3){
                  obj[villager.colorSegment] = {
                    id: i+1,
                    label: villager.colorSegment,
                    row: Math.floor(uniqueCount / skincolorPerRow) + 1,
                    count: 1,
                    x: (uniqueCount % skincolorPerRow + 1) * skincolorRowWidth - skincolorTopSpace/3,
                    y: (Math.floor(uniqueCount / skincolorPerRow) + skincolorY) * skincolorRowPadding - skincolorTopSpace*1.5,
                  };
                }else{
                  obj[villager.colorSegment] = {
                    id: i+1,
                    label: villager.colorSegment,
                    row: Math.floor(uniqueCount / skincolorPerRow) + 1,
                    count: 1,
                    x: (uniqueCount % skincolorPerRow + 1) * skincolorRowWidth - skincolorTopSpace/3,
                    y: (Math.floor(uniqueCount / skincolorPerRow) + skincolorY) * skincolorRowPadding - skincolorTopSpace*1,
                }
              };

             uniqueCount++

           }
          return obj;
        }, {});

      // Goodlooking Position

        let goodlookingPerRow = 3,
            goodlookingRowWidth = chartWidth / (goodlookingPerRow + 1),
            goodlookingRowPadding = chartWidth / (goodlookingPerRow + 0),
            goodlookingY = 0.8,
            goodlookingLeftpSpace = 0.4;

        if( window.innerWidth <= mobileBreakpoint){
          goodlookingPerRow = 1;
          goodlookingRowWidth = chartWidth / (goodlookingPerRow + 1);
          goodlookingY = 0.45;
          goodlookingRowPadding = radius*10;
          goodlookingLeftpSpace = 0.2;
        }


          this.topVillagerGoodlookingNodes = topVillagers.sort((a,b)=>b.Apperance_Score-a.Apperance_Score).reduce((obj, villager, i) => {
            let uniqueCount = Object.keys(obj).length;
            if (obj[villager.Apperance_Score]){
                ++obj[villager.Apperance_Score].count;
            } else {
              let itemRow = Math.floor(uniqueCount / goodlookingPerRow) + 1;
              if(itemRow === 3){
                obj[villager.Apperance_Score] = {
                  id: i+1,
                  label: villager.Apperance_Score,
                  count: 1,
                  x: (uniqueCount % goodlookingPerRow + 1) * goodlookingRowWidth * 1.2 - goodlookingRowWidth*goodlookingLeftpSpace,
                  y: (Math.floor(uniqueCount / goodlookingPerRow) + goodlookingY) * goodlookingRowPadding - radius *1,
                };
              }else{
                obj[villager.Apperance_Score] = {
                  id: i+1,
                  label: villager.Apperance_Score,
                  count: 1,
                  x: (uniqueCount % goodlookingPerRow + 1) * goodlookingRowWidth * 1.2 - goodlookingRowWidth*goodlookingLeftpSpace,
                  y: (Math.floor(uniqueCount / goodlookingPerRow) + goodlookingY) * goodlookingRowPadding,
                };
              }

              uniqueCount++
            }
           return obj;
         }, {});

         // skinColorBrightness Position
         let brightnessPerRow = 3,
             brightnessRowWidth = chartWidth / (brightnessPerRow + 1),
             brightnessRowPadding = chartWidth / (brightnessPerRow + 0),
             brightnessY =0.8,
             brightnessLeftpSpace = 0.4,
             sortByBrightness = brightness;

         if( window.innerWidth <= mobileBreakpoint){
           brightnessPerRow = 1;
           brightnessRowWidth = chartWidth / (brightnessPerRow + 1);
           brightnessY = 0.3;
           brightnessRowPadding = radius*9.5;
           brightnessLeftpSpace = 0.2;
         }

           this.topVillagerBrightnessNodes =   topVillagers.sort((a,b)=> sortByBrightness.indexOf(a.skinColorBrightness) - sortByBrightness.indexOf(b.skinColorBrightness)).reduce((obj, villager, i) => {
             let uniqueCount = Object.keys(obj).length;
             if (obj[villager.skinColorBrightness]){
                 ++obj[villager.skinColorBrightness].count;
             } else {
               let itemRow = Math.floor(uniqueCount / brightnessPerRow) + 1;
               if(itemRow === 2){
                 obj[villager.skinColorBrightness] = {
                   id: i+1,
                   label: villager.skinColorBrightness,
                   count: 1,
                   x: (uniqueCount % brightnessPerRow + 1) * brightnessRowWidth * 1.2 - brightnessRowWidth*brightnessLeftpSpace,
                   y: (Math.floor(uniqueCount / brightnessPerRow) + brightnessY) * brightnessRowPadding - radius *1.25,
                 };
               }else{
                 obj[villager.skinColorBrightness] = {
                   id: i+1,
                   label: villager.skinColorBrightness,
                   count: 1,
                   x: (uniqueCount % brightnessPerRow + 1) * brightnessRowWidth * 1.2 - brightnessRowWidth*brightnessLeftpSpace,
                   y: (Math.floor(uniqueCount / brightnessPerRow) + brightnessY) * brightnessRowPadding,
                 };
               }

               uniqueCount++
             }
            return obj;
          }, {});


     //assign position
     topVillagers.forEach((villager) => {
        var topVillagerNode = this.topVillagerNodes[villager.name],
            personalityNode = this.topVillagerPersonalityNodes[villager.personality],
            speciesNode = this.topVillagerSpeciesNodes[villager.species],
            starsignNode = this.topVillagerStarSignNodes[villager.sign],
            hobbyNode = this.topVillagerHobbyNodes[villager.hobby],
            goodlookinNode = this.topVillagerGoodlookingNodes[villager.Apperance_Score],
            skincolorNode = this.topVillagerSkincolorNodes[villager.colorSegment],
            brightnessNode = this.topVillagerBrightnessNodes[villager.skinColorBrightness];

        villager.defaultX = topVillagerNode.x;
        villager.defaultY = topVillagerNode.y;

        villager.pX = personalityNode.x;
        villager.pY = personalityNode.y;

        villager.sX = speciesNode.x;
        villager.sY = speciesNode.y;

        villager.ssX = starsignNode.x;
        villager.ssY = starsignNode.y;

        villager.hX = hobbyNode.x;
        villager.hY = hobbyNode.y;

        villager.gX = goodlookinNode.x;
        villager.gY = goodlookinNode.y;

        villager.scX = skincolorNode.x;
        villager.scY = skincolorNode.y;

        villager.sbX = brightnessNode.x;
        villager.sbY = brightnessNode.y;

      });

     let topVillagerNodes = this.topVillagerNodes,
         svgVillagerNode = this.svg.selectAll('.node'),
         svgVillagerLabel = this.svg.selectAll('.villager-label-container'),
         tooltipPhrase = d3.select('#tooltip-phrase');


      if(step === "traits-personality"){
        svgVillagerNode.style("stroke", "transparent")
                        .style("fill", d => `url(#villager-thumbnail-${d.name})`)
                        .on("mouseenter", function(e,d) {
                          let thisCircle = d3.select(this);
                          let circleColor = skinColors.get(d.id);

                          /* calculate position */
                          let ePosition =  e.target.getBoundingClientRect(),
                              toolTipWidth = 200;

                          let lPosition = ePosition.left,
                              tPosition = ePosition.top;

                          let y =  window.scrollY + tPosition + radius*1.25;

                          let isPointRight = ((chartWidth - lPosition) <= toolTipWidth)?true:false;
                          let xPosition= lPosition + radius * 1.8;

                          let x = (isPointRight)?(xPosition - toolTipWidth - radius * 3.15):xPosition;

                          tooltipPhrase.attr("class", (isPointRight?'right':'left'))
                                      .transition()
                                      .duration(200)
                                      .style("display", "block")

                          tooltipPhrase.html(
                                          `<p>${greetings[d.personality]}, I'm <strong>${d.name}</strong>. I'm a <i>${d.personality}</i> villager.</p>`
                                      )
                                      .style("transform",`none`)
                                      .style("top",`${y}px`)
                                      .style("left", `${x}px`);

                          thisCircle.raise()
                                    .transition()
                                    .duration(550)
                                    .style("fill", d => `url(#villager-thumbnail-${d.name})`)
                                    //.style("stroke", d => skinColors.get(d.id))
                                    .attr("r", radius*1.2);

                           d3.select(`#def-villager-bg-${d.name}`)
                              .transition()
                              .attr("fill-opacity", 0.8)
                              //.attr("fill", acnhColors.bgOrangeColor)
                              .style("stroke", acnhColors.borderYellowColor)
                              //.attr("transform", `scale(1) translate(0,0)`);

                        })
                        .on('mouseleave', function(e,d){
                            d3.select('#tooltip-phrase')
                                        .transition()
                                        .duration(200)
                                        .style("display", "none")

                            let thisCircle = d3.select(this);
                            thisCircle.lower()
                                      .transition()
                                      .duration(550)
                                      .style("fill", d => `url(#villager-thumbnail-${d.name})`)
                                      .style("stroke", 'none')
                                      .attr("r", radius);

                            d3.select(`#def-villager-bg-${d.name}`)
                               .transition()
                               .style("stroke", "transparent")
                               .attr("fill-opacity", 0.3)
                               .attr("fill", acnhColors.themeColor)

                          })


         let labelNodes = Object.values(this.topVillagerPersonalityNodes);

         let labelG =  svgVillagerLabel.selectAll(".villager-label").data(labelNodes).join("g").classed('villager-label', true)

         labelG.append("text")
             .classed('villager-label-text', true)
             .text((d) => `${d.label}`)
             .style("text-anchor", "middle")
             .attr('x', d => d.x)
             .attr('y', d => d.y + radius*4.5);


        this.simulation.force('x', d3.forceX().x(d => d.pX))
          .force('y', d3.forceY().y(d => d.pY))
          .force('collide', d3.forceCollide().radius(radius+1).strength(0.8))
          .alpha(1).restart();

      }else if(step === "traits-house"){

        svgVillagerNode.style("fill", d => (d.Combined_Special_House_Style === 'special')?`url(#villager-s-house-thumbnail-${d.name})`:`url(#villager-house-thumbnail-${d.name})`)
                        //.style("fill", d => `url(#villager-thumbnail-${d.name})`)
                       .style("stroke", "transparent")
                       .on("mouseenter", function(e,d) {
                         let thisCircle = d3.select(this);
                         let circleColor = skinColors.get(d.id);

                         /* calculate position */
                         let ePosition =  e.target.getBoundingClientRect(),
                             toolTipWidth = 200;

                         let lPosition = ePosition.left,
                             tPosition = ePosition.top;

                         let y =  window.scrollY + tPosition + radius*1.25;

                         let isPointRight = ((chartWidth - lPosition) <= toolTipWidth)?true:false;
                         let xPosition= lPosition + radius * 1.8;

                         let x = (isPointRight)?(xPosition - toolTipWidth - radius * 3.15):xPosition;

                         tooltipPhrase.attr("class", (isPointRight?'right':'left'))
                                     .transition()
                                     .duration(200)
                                     .style("display", "block")

                         tooltipPhrase.html(
                                         `<p>${greetings[d.personality]}, I'm <strong>${d.name}</strong>, living in a <i>${(d.Combined_Special_House_Style === 'special')?`unique ${d.interior_decor} style`:'normal'}</i> house.</p>`
                                     )
                                     .style("transform",`none`)
                                     .style("top",`${y}px`)
                                     .style("left", `${x}px`);


                         if(d.Combined_Special_House_Style === 'special'){
                           thisCircle.raise()
                                     .transition()
                                     .duration(550)
                                     .style("fill", `url(#villager-s-house-thumbnail-${d.name})`)
                                     .attr("r", radius*1.2);

                         }else{
                           thisCircle.raise()
                                     .transition()
                                     .duration(550)
                                     .style("fill", `url(#villager-house-thumbnail-${d.name})`)
                                     .attr("r", radius*1.2);

                            d3.select(`#def-house-bg-${d.name}`)
                               .transition()
                               .attr("fill-opacity", 0.8)
                               .style("stroke", acnhColors.borderYellowColor)
                         }


                       })
                       .on("mouseleave", function(e,d) {
                         tooltipPhrase.style("display", "none"); // Hide toolTip

                         let thisCircle = d3.select(this);

                         if(d.Combined_Special_House_Style === 'special'){
                           thisCircle.lower()
                                     .transition()
                                     .duration(550)
                                     .style("fill", `url(#villager-s-house-thumbnail-${d.name})`)
                                     .attr("r", radius);

                         }else{
                           thisCircle.lower()
                                     .transition()
                                     .duration(550)
                                     .style("fill", `url(#villager-house-thumbnail-${d.name})`)
                                     .attr("r", radius);

                            d3.select(`#def-house-bg-${d.name}`)
                               .transition()
                               .attr("fill-opacity", 0.3)
                               .style("stroke", "transparent")
                         }
                      });


                let labelNodes = Object.values(this.topVillagerNodes);

                let labelG =  svgVillagerLabel.selectAll(".villager-label").data(labelNodes).join("g").classed('villager-label', true)

                labelG.append("text")
                    .classed('villager-label-text', true)
                    .text((d) => `${d.label}`)
                    .style("text-anchor", "middle")
                    .attr('x', d => d.x)
                    .attr('y', d => (window.innerWidth <= mobileBreakpoint)?(d.y + radius*1.5):(d.y + radius*1.8));

                this.simulation.force('x', d3.forceX().x(d => d.defaultX))
                .force('y', d3.forceY().y(d => d.defaultY))
                .force('collide', d3.forceCollide().radius(radius+1).strength(0.8))
                .alpha(1).restart();


      }else if(step === "gameplay-amiibo"){
        svgVillagerNode.style("fill", d => (d.Amiibo === 'NO')?`url(#villager-thumbnail-s-${d.name})`:`url(#villager-thumbnail-${d.name})`)
                       .on("mouseenter", function(e,d) {
                         let thisCircle = d3.select(this);
                         let circleColor = skinColors.get(d.id);

                         /* calculate position */
                         let ePosition =  e.target.getBoundingClientRect(),
                             toolTipWidth = 200;

                         let lPosition = ePosition.left,
                             tPosition = ePosition.top;

                         let y =  window.scrollY + tPosition + radius*1.25;

                         let isPointRight = ((chartWidth - lPosition) <= toolTipWidth)?true:false;
                         let xPosition= lPosition + radius * 1.8;

                         let x = (isPointRight)?(xPosition - toolTipWidth - radius * 3.15):xPosition;

                         tooltipPhrase.attr("class", (isPointRight?'right':'left'))
                                     .transition()
                                     .duration(200)
                                     .style("display", "block")

                         tooltipPhrase.html(
                                         `<p>${greetings[d.personality]}, I'm <strong>${d.name}</strong>, <i>${d.phrase}</i></p>`
                                     )
                                     .style("transform",`none`)
                                     .style("top",`${y}px`)
                                     .style("left", `${x}px`);

                         if(d.Amiibo === 'NO'){
                           thisCircle.raise()
                                     .transition()
                                     .duration(550)
                                     .style("fill", `url(#villager-thumbnail-s-${d.name})`)
                                     .attr("r", radius*1.2);

                             d3.select(`#def-villager-s-bg-${d.name}`)
                                .transition()
                                .attr("fill-opacity", 0.8)
                                .style("stroke", acnhColors.borderYellowColor)

                         }else{
                           thisCircle.raise()
                                     .transition()
                                     .duration(550)
                                     .style("fill", `url(#villager-thumbnail-${d.name})`)
                                     .attr("r", radius*1.2);

                            d3.select(`#def-villager-bg-${d.name}`)
                               .transition()
                               .attr("fill-opacity", 0.8)
                               .style("stroke", acnhColors.borderYellowColor)
                         }


                       })
                       .on("mouseleave", function(e,d) {
                         tooltipPhrase.style("display", "none"); // Hide toolTip

                         let thisCircle = d3.select(this);

                         if(d.Amiibo === 'NO'){
                           thisCircle.lower()
                                     .transition()
                                     .duration(550)
                                     .style("fill", `url(#villager-thumbnail-s-${d.name})`)
                                     .attr("r", radius);
                           d3.select(`#def-villager-s-bg-${d.name}`)
                              .transition()
                              .attr("fill-opacity", 0.3)
                              .style("stroke", "transparent")


                         }else{
                           thisCircle.lower()
                                     .transition()
                                     .duration(550)
                                     .style("fill", `url(#villager-thumbnail-${d.name})`)
                                     .attr("r", radius);

                            d3.select(`#def-villager-bg-${d.name}`)
                               .transition()
                               .attr("fill-opacity", 0.3)
                               .style("stroke", "transparent")
                         }
                      });


        let labelNodes = Object.values(this.topVillagerNodes);

        let labelG =  svgVillagerLabel.selectAll(".villager-label").data(labelNodes).join("g").classed('villager-label', true)

        labelG.append("text")
            .classed('villager-label-text', true)
            .text((d) => `${d.label}`)
            .style("text-anchor", "middle")
            .attr('x', d => d.x)
            .attr('y', d => (window.innerWidth <= mobileBreakpoint)?(d.y + radius*1.5):(d.y + radius*1.8));

        this.simulation.force('x', d3.forceX().x(d => d.defaultX))
        .force('y', d3.forceY().y(d => d.defaultY))
        .force('collide', d3.forceCollide().radius(radius+1).strength(0.8))
        .alpha(1).restart();



      }else if(step === "traits-species" || step === "gameplay-rarity"){

        svgVillagerNode.style("stroke", 'none')
                       .style("fill", d => `url(#villager-thumbnail-${d.name})`)
                       .on("mouseenter", function(e,d) {
                         let thisCircle = d3.select(this);
                         let circleColor = skinColors.get(d.id);

                         /* calculate position */
                         let ePosition =  e.target.getBoundingClientRect(),
                             toolTipWidth = 200;

                         let lPosition = ePosition.left,
                             tPosition = ePosition.top;

                         let y =  window.scrollY + tPosition + radius*1.25;

                         let isPointRight = ((chartWidth - lPosition) <= toolTipWidth)?true:false;
                         let xPosition= lPosition + radius * 1.8;

                         let x = (isPointRight)?(xPosition - toolTipWidth - radius * 3.15):xPosition;

                         tooltipPhrase.attr("class", (isPointRight?'right':'left'))
                                     .transition()
                                     .duration(200)
                                     .style("display", "block")

                         tooltipPhrase.html(
                                         `<p>${greetings[d.personality]}, my name is <strong>${d.name}</strong>. I'm a <i>${d.species}</i> villager.</p>`
                                     )
                                     .style("transform",`none`)
                                     .style("top",`${y}px`)
                                     .style("left", `${x}px`);

                         thisCircle.raise()
                                   .transition()
                                   .duration(550)
                                   .style("fill", d => `url(#villager-thumbnail-${d.name})`)
                                   //.style("stroke", d => skinColors.get(d.id))
                                   .attr("r", radius*1.2);

                          d3.select(`#def-villager-bg-${d.name}`)
                             .transition()
                             .attr("fill-opacity", 0.8)
                             //.attr("fill", acnhColors.bgOrangeColor)
                             .style("stroke", acnhColors.borderYellowColor)
                             //.attr("transform", `scale(1) translate(0,0)`);

                       })
                       .on('mouseleave', function(e,d){
                           d3.select('#tooltip-phrase')
                                       .transition()
                                       .duration(200)
                                       .style("display", "none")

                           let thisCircle = d3.select(this);
                           thisCircle.lower()
                                     .transition()
                                     .duration(550)
                                     .style("fill", d => `url(#villager-thumbnail-${d.name})`)
                                     .style("stroke", 'none')
                                     .attr("r", radius);

                           d3.select(`#def-villager-bg-${d.name}`)
                              .transition()
                              .style("stroke", "transparent")
                              .attr("fill-opacity", 0.3)
                              .attr("fill", acnhColors.themeColor)

                         })


        let labelNodes = Object.values(this.topVillagerSpeciesNodes);

        let labelG =  svgVillagerLabel.selectAll(".villager-label").data(labelNodes).join("g").classed('villager-label', true)


        let xStrength = 0.12,
            labelD = radius*3.75;

        if(window.innerWidth <= mobileBreakpoint){
           xStrength = 0.1;
           labelD = radius*3.5;
        }

        labelG.append("text")
            .classed('villager-label-text', true)
            .text((d) => `${d.label}`)
            .style("text-anchor", "middle")
            .attr('x', d => d.x)
            .attr('y', d => d.y + labelD);

        this.simulation.force('x', d3.forceX().x(d => d.sX).strength(xStrength))
          .force('y', d3.forceY().y(d => d.sY))
          .force('collide', d3.forceCollide().radius(radius+1).strength(0.8))
          .alpha(1).restart();


      }else if(step === "appearance-unique"){
        svgVillagerNode.style("fill", d => (d.Combined_special_appearance === 'special')?`url(#villager-thumbnail-s-${d.name})`:`url(#villager-thumbnail-${d.name})`)
                       .on("mouseenter", function(e,d) {
                         let thisCircle = d3.select(this);
                         let circleColor = skinColors.get(d.id);

                         /* calculate position */
                         let ePosition =  e.target.getBoundingClientRect(),
                             toolTipWidth = 200;

                         let lPosition = ePosition.left,
                             tPosition = ePosition.top;

                         let y =  window.scrollY + tPosition + radius*1.25;

                         let isPointRight = ((chartWidth - lPosition) <= toolTipWidth)?true:false;
                         let xPosition= lPosition + radius * 1.8;

                         let x = (isPointRight)?(xPosition - toolTipWidth - radius * 3.15):xPosition;

                         tooltipPhrase.attr("class", (isPointRight?'right':'left'))
                                     .transition()
                                     .duration(200)
                                     .style("display", "block")

                         tooltipPhrase.html(
                                         `<p>${greetings[d.personality]}, I'm <strong>${d.name}</strong>. I have a  <i>${(d.Combined_special_appearance === 'special')?`unique`:'normal'}</i> appearance.</p>`
                                     )
                                     .style("transform",`none`)
                                     .style("top",`${y}px`)
                                     .style("left", `${x}px`);

                         if(d.Combined_special_appearance=== 'special'){
                           thisCircle.raise()
                                     .transition()
                                     .duration(550)
                                     .style("fill", `url(#villager-thumbnail-s-${d.name})`)
                                     .attr("r", radius*1.2);

                             d3.select(`#def-villager-s-bg-${d.name}`)
                                .transition()
                                .attr("fill-opacity", 0.8)
                                .style("stroke", acnhColors.borderYellowColor)

                         }else{
                           thisCircle.raise()
                                     .transition()
                                     .duration(550)
                                     .style("fill", `url(#villager-thumbnail-${d.name})`)
                                     .attr("r", radius*1.2);

                            d3.select(`#def-villager-bg-${d.name}`)
                               .transition()
                               .attr("fill-opacity", 0.8)
                               .style("stroke", acnhColors.borderYellowColor)
                         }


                       })
                       .on("mouseleave", function(e,d) {
                         tooltipPhrase.style("display", "none"); // Hide toolTip

                         let thisCircle = d3.select(this);

                         if(d.Combined_special_appearance === 'special'){
                           thisCircle.lower()
                                     .transition()
                                     .duration(550)
                                     .style("fill", `url(#villager-thumbnail-s-${d.name})`)
                                     .attr("r", radius);
                           d3.select(`#def-villager-s-bg-${d.name}`)
                              .transition()
                              .attr("fill-opacity", 0.3)
                              .style("stroke", "transparent")


                         }else{
                           thisCircle.lower()
                                     .transition()
                                     .duration(550)
                                     .style("fill", `url(#villager-thumbnail-${d.name})`)
                                     .attr("r", radius);

                            d3.select(`#def-villager-bg-${d.name}`)
                               .transition()
                               .attr("fill-opacity", 0.3)
                               .style("stroke", "transparent")
                         }
                      });


        let labelNodes = Object.values(this.topVillagerNodes);

        let labelG =  svgVillagerLabel.selectAll(".villager-label").data(labelNodes).join("g").classed('villager-label', true)

        labelG.append("text")
            .classed('villager-label-text', true)
            .text((d) => `${d.label}`)
            .style("text-anchor", "middle")
            .attr('x', d => d.x)
            .attr('y', d => (window.innerWidth <= mobileBreakpoint)?(d.y + radius*1.5):(d.y + radius*1.8));


        this.simulation.force('x', d3.forceX().x(d => d.defaultX))
        .force('y', d3.forceY().y(d => d.defaultY))
        .force('collide', d3.forceCollide().radius(radius+1).strength(0.8))
        .alpha(1).restart();

      }else if(step === "appearance-goodlooking"){

        let colorWheelObj = ChartSpecs.chartspecs.colorWheelObjGoodlooking;
        let colorWheelArray = Object.keys(colorWheelObj),
            colorRange = Object.values(colorWheelObj);

        const colorScale = d3.scaleOrdinal()
                            .domain(colorWheelArray)
                            .range(colorRange);

        let goodlookingXScale = d3.scaleBand()
                                  //.domain(this.topVillagerGoodlookingNodes.map(d => d[0])) // Apperance_Score
                                  .domain([5,4,3])
                                  .range([chartWidth/6, chartWidth*1.175]);

        svgVillagerNode.style("stroke", 'none')
                       .style("fill", d => `url(#villager-thumbnail-${d.name})`)
                       //.style("fill", function(d) {
                        //  d3.select(`#def-villager-bg-${d.name}`)
                          //  .attr("fill", d => colorScale(goodlookingScores[d.Apperance_Score]))
                          // .attr("fill-opacity", 1)

                         //return `url(#villager-thumbnail-${d.name})`
                       //})
                       .on("mouseenter", function(e,d) {
                         let thisCircle = d3.select(this);
                         let circleColor = skinColors.get(d.id);

                         /* calculate position */
                         let ePosition =  e.target.getBoundingClientRect(),
                             toolTipWidth = 200;

                         let lPosition = ePosition.left,
                             tPosition = ePosition.top;

                         let y =  window.scrollY + tPosition + radius*1.25;

                         let isPointRight = ((chartWidth - lPosition) <= toolTipWidth)?true:false;
                         let xPosition= lPosition + radius * 1.8;

                         let x = (isPointRight)?(xPosition - toolTipWidth - radius * 3.15):xPosition;

                         tooltipPhrase.attr("class", (isPointRight?'right':'left'))
                                     .transition()
                                     .duration(200)
                                     .style("display", "block")

                         tooltipPhrase.html(
                                         `<p>${greetings[d.personality]}, I'm <strong>${d.name}</strong>. My appearance is <i>${goodlookingScores[d.Apperance_Score]}</i>.</p>`
                                     )
                                     .style("transform",`none`)
                                     .style("top",`${y}px`)
                                     .style("left", `${x}px`);

                         thisCircle.raise()
                                   .transition()
                                   .duration(550)
                                   .style("fill", d => `url(#villager-thumbnail-${d.name})`)
                                   //.style("stroke", d => skinColors.get(d.id))
                                   .attr("r", radius*1.2);

                          d3.select(`#def-villager-bg-${d.name}`)
                             .transition()
                             .attr("fill-opacity", 0.8)
                             //.attr("fill", acnhColors.bgOrangeColor)
                             .style("stroke", acnhColors.borderYellowColor)
                             //.attr("transform", `scale(1) translate(0,0)`);

                       })
                       .on("mouseleave", function(e,d) {
                         tooltipPhrase.style("display", "none"); // Hide toolTip
                         let thisCircle = d3.select(this);

                         thisCircle.lower()
                                   .transition()
                                   .duration(550)
                                   .style("fill", d => `url(#villager-thumbnail-${d.name})`)
                                   .attr("r", radius);

                          d3.select(`#def-villager-bg-${d.name}`)
                             .transition()
                             .attr("fill-opacity", 0.3)
                             .style("stroke", "transparent")

                         });

         let labelNodes = Object.values(this.topVillagerGoodlookingNodes);

         let labelG =  svgVillagerLabel.selectAll(".villager-label").data(labelNodes).join("g").classed('villager-label', true)

         let xStrength = 0.2,
             labelD =  radius*7;

         if(window.innerWidth <= mobileBreakpoint){
            xStrength = 0.02;
            labelD = radius*4.75;
         }

         labelG.append("text")
             .classed('villager-label-text', true)
             .text((d) => `${goodlookingScores[d.label]}`)
             .style("text-anchor", "middle")
             .attr('x', d => d.x)
             .attr('y', d => d.y + labelD);

         this.simulation.force('x', d3.forceX().x(d => d.gX).strength(xStrength))
           .force('y', d3.forceY().y(d => d.gY))
           .force('collide', d3.forceCollide().radius(radius+1).strength(0.8))
           .alpha(1).restart();


      }else if(step === "appearance-skinbrightness"){
        svgVillagerNode.style("stroke", 'none')
                       .style("fill", d => `url(#villager-thumbnail-${d.name})`)
                       .on("mouseenter", function(e,d) {
                         let thisCircle = d3.select(this);
                         let circleColor = skinColors.get(d.id);

                         /* calculate position */
                         let ePosition =  e.target.getBoundingClientRect(),
                             toolTipWidth = 200;

                         let lPosition = ePosition.left,
                             tPosition = ePosition.top;

                         let y =  window.scrollY + tPosition + radius*1.25;

                         let isPointRight = ((chartWidth - lPosition) <= toolTipWidth)?true:false;
                         let xPosition= lPosition + radius * 1.8;

                         let x = (isPointRight)?(xPosition - toolTipWidth - radius * 3.15):xPosition;

                         tooltipPhrase.attr("class", (isPointRight?'right':'left'))
                                     .transition()
                                     .duration(200)
                                     .style("display", "block")

                         tooltipPhrase.html(
                                         `<p>${greetings[d.personality]}, I'm <strong>${d.name}</strong>. I have a <i>${d.skinColorBrightness}</i> skin color.</p>`
                                     )
                                     .style("transform",`none`)
                                     .style("top",`${y}px`)
                                     .style("left", `${x}px`);

                         thisCircle.raise()
                                   .transition()
                                   .duration(550)
                                   .style("fill", d => `url(#villager-thumbnail-${d.name})`)
                                   //.style("stroke", d => skinColors.get(d.id))
                                   .attr("r", radius*1.2);

                          d3.select(`#def-villager-bg-${d.name}`)
                             .transition()
                             .attr("fill-opacity", 0.8)
                             //.attr("fill", acnhColors.bgOrangeColor)
                             .style("stroke", acnhColors.borderYellowColor)
                             //.attr("transform", `scale(1) translate(0,0)`);

                       })
                       .on("mouseleave", function(e,d) {
                         tooltipPhrase.style("display", "none"); // Hide toolTip
                         let thisCircle = d3.select(this);
                         thisCircle.lower()
                                   .transition()
                                   .duration(550)
                                   .style("fill", `url(#villager-thumbnail-${d.name})`)
                                   .attr("r", radius);

                          d3.select(`#def-villager-bg-${d.name}`)
                             .transition()
                             .attr("fill-opacity", 0.3)
                             .style("stroke", "transparent")
                         });



       let labelNodes = Object.values(this.topVillagerBrightnessNodes);

       let labelG =  svgVillagerLabel.selectAll(".villager-label").data(labelNodes).join("g").classed('villager-label', true)

       let xStrength = 0.2,
            labelD =  radius*7.2;

       if(window.innerWidth <= mobileBreakpoint){
         xStrength = 0.02;
         labelD = radius*4.7;
       }


       labelG.append("text")
           .classed('villager-label-text', true)
           .text((d) => `${d.label}`)
           .style("text-anchor", "middle")
           .attr('x', d => d.x)
           .attr('y', d => (d.label === 'Dark' && xStrength ===0.02)?(d.y + labelD)/1.5:(d.y + labelD));

       this.simulation.force('x', d3.forceX().x(d => d.sbX).strength(xStrength))
         .force('y', d3.forceY().y(d => d.sbY))
         .force('collide', d3.forceCollide().radius(radius+1).strength(0.8))
         .alpha(1).restart();

      }else if(step === "appearance-skincolor"){


        svgVillagerNode.style("stroke", 'none')
        .style("fill", d => `url(#villager-thumbnail-${d.name})`)
        .on("mouseenter", function(e,d) {
          let thisCircle = d3.select(this);
          let circleColor = skinColors.get(d.id);

          /* calculate position */
          let ePosition =  e.target.getBoundingClientRect(),
              toolTipWidth = 200;

          let lPosition = ePosition.left,
              tPosition = ePosition.top;

          let y =  window.scrollY + tPosition + radius*1.25;

          let isPointRight = ((chartWidth - lPosition) <= toolTipWidth)?true:false;
          let xPosition= lPosition + radius * 1.8;

          let x = (isPointRight)?(xPosition - toolTipWidth - radius * 3.15):xPosition;

          tooltipPhrase.attr("class", (isPointRight?'right':'left'))
                      .transition()
                      .duration(200)
                      .style("display", "block")

          tooltipPhrase.html(
                          `<p>${greetings[d.personality]}, I'm <strong>${d.name}</strong>. My skin tone is <i>${d.colorSegment}</i>.</p>`
                      )
                      .style("transform",`none`)
                      .style("top",`${y}px`)
                      .style("left", `${x}px`);

          thisCircle.raise()
                    .transition()
                    .duration(550)
                    .style("fill", d => `url(#villager-thumbnail-${d.name})`)
                    //.style("stroke", d => skinColors.get(d.id))
                    .attr("r", radius*1.2);

           d3.select(`#def-villager-bg-${d.name}`)
              .transition()
              .attr("fill-opacity", 0.8)
              //.attr("fill", acnhColors.bgOrangeColor)
              .style("stroke", acnhColors.borderYellowColor)
              //.attr("transform", `scale(1) translate(0,0)`);

        })
        .on("mouseleave", function(e,d) {
          tooltipPhrase.style("display", "none"); // Hide toolTip

          let thisCircle = d3.select(this);

          thisCircle.lower()
                    .transition()
                    .duration(550)
                    .style("fill", `url(#villager-thumbnail-${d.name})`)
                    .attr("r", radius);

           d3.select(`#def-villager-bg-${d.name}`)
              .transition()
              .attr("fill-opacity", 0.3)
              .style("stroke", "transparent")
          });


          let labelNodes = Object.values(this.topVillagerSkincolorNodes);

          let labelG =  svgVillagerLabel.selectAll(".villager-label").data(labelNodes).join("g").classed('villager-label', true)

          labelG.append("text")
              .classed('villager-label-text', true)
              .text((d) => `${d.label}`)
              .style("text-anchor", "middle")
              .style("text-transform", "capitalize")
              .attr('x', d => d.x)
              .attr('y', d => (d.row === 1)?(d.y + radius*5):(d.y + radius*4));

        this.simulation.force('x', d3.forceX().x(d => d.scX))
          .force('y', d3.forceY().y(d => d.scY))
          .force('collide', d3.forceCollide().radius(radius+1).strength(0.8))
          .alpha(1).restart();


      }else if(step === "traits-hobby"){
        svgVillagerNode.style("fill", d => `url(#villager-thumbnail-${d.name})`)
        .on("mouseenter", function(e,d) {

          let thisCircle = d3.select(this);
          let circleColor = skinColors.get(d.id);

          /* calculate position */
          let ePosition =  e.target.getBoundingClientRect(),
              toolTipWidth = 200;

          let lPosition = ePosition.left,
              tPosition = ePosition.top;

          let y =  window.scrollY + tPosition + radius*1.25;

          let isPointRight = ((chartWidth - lPosition) <= toolTipWidth)?true:false;
          let xPosition= lPosition + radius * 1.8;

          let x = (isPointRight)?(xPosition - toolTipWidth - radius * 3.15):xPosition;

          tooltipPhrase.attr("class", (isPointRight?'right':'left'))
                      .transition()
                      .duration(200)
                      .style("display", "block")

          tooltipPhrase.html(
                          `<p>${greetings[d.personality]}, I'm <strong>${d.name}</strong>. <i>I like ${d.hobby}<i>.</p>`
                      )
                      .style("transform",`none`)
                      .style("top",`${y}px`)
                      .style("left", `${x}px`);

          thisCircle.raise()
                    .transition()
                    .duration(550)
                    .style("fill", d => `url(#villager-thumbnail-${d.name})`)
                    //.style("stroke", d => skinColors.get(d.id))
                    .attr("r", radius*1.2);

           d3.select(`#def-villager-bg-${d.name}`)
              .transition()
              .attr("fill-opacity", 0.8)
              //.attr("fill", acnhColors.bgOrangeColor)
              .style("stroke", acnhColors.borderYellowColor)
              //.attr("transform", `scale(1) translate(0,0)`);

        })
        .on("mouseleave", function(e,d) {
          tooltipPhrase.style("display", "none"); // Hide toolTip

          let thisCircle = d3.select(this);

          thisCircle.lower()
                    .transition()
                    .duration(550)
                    .style("fill", `url(#villager-thumbnail-${d.name})`)
                    .attr("r", radius);

           d3.select(`#def-villager-bg-${d.name}`)
              .transition()
              .attr("fill-opacity", 0.3)
              .style("stroke", "transparent")

          });

        let labelNodes = Object.values(this.topVillagerHobbyNodes);

        let labelG =  svgVillagerLabel.selectAll(".villager-label").data(labelNodes).join("g").classed('villager-label', true)

        labelG.append("text")
            .classed('villager-label-text', true)
            .text((d) => `${d.label}`)
            .style("text-anchor", "middle")
            .attr('x', d => d.x)
            .attr('y', d => d.y + radius*4.2);

        this.simulation.force('x', d3.forceX().x(d => d.hX))
          .force('y', d3.forceY().y(d => d.hY))
          .force('collide', d3.forceCollide().radius(radius+1).strength(0.8))
          .alpha(1).restart();

      }else if(step === "traits-star-sign"){

        svgVillagerNode.style("fill", d => `url(#villager-thumbnail-${d.name})`)
        .on("mouseenter", function(e,d) {
          let thisCircle = d3.select(this);
          let circleColor = skinColors.get(d.id);

          /* calculate position */
          let ePosition =  e.target.getBoundingClientRect(),
              toolTipWidth = 200;

          let lPosition = ePosition.left,
              tPosition = ePosition.top;

          let y =  window.scrollY + tPosition + radius*1.25;

          let isPointRight = ((chartWidth - lPosition) <= toolTipWidth)?true:false;
          let xPosition= lPosition + radius * 1.8;

          let x = (isPointRight)?(xPosition - toolTipWidth - radius * 3.15):xPosition;

          tooltipPhrase.attr("class", (isPointRight?'right':'left'))
                      .transition()
                      .duration(200)
                      .style("display", "block")

          tooltipPhrase.html(
                          `<p>${greetings[d.personality]}, I'm <strong>${d.name}</strong>. I'm ${(d.sign === 'Aries' || d.sign === 'Aquarius')?'an':'a'} <i>${d.sign}</i>.</p>`
                      )
                      .style("transform",`none`)
                      .style("top",`${y}px`)
                      .style("left", `${x}px`);

          thisCircle.raise()
                    .transition()
                    .duration(550)
                    .style("fill", d => `url(#villager-thumbnail-${d.name})`)
                    //.style("stroke", d => skinColors.get(d.id))
                    .attr("r", radius*1.2);

           d3.select(`#def-villager-bg-${d.name}`)
              .transition()
              .attr("fill-opacity", 0.8)
              //.attr("fill", acnhColors.bgOrangeColor)
              .style("stroke", acnhColors.borderYellowColor)
              //.attr("transform", `scale(1) translate(0,0)`);

        })
        .on("mouseleave", function(e,d) {
          tooltipPhrase.style("display", "none"); // Hide toolTip

          let thisCircle = d3.select(this);

          thisCircle.lower()
                    .transition()
                    .duration(550)
                    .style("fill", `url(#villager-thumbnail-${d.name})`)
                    .attr("r", radius);

           d3.select(`#def-villager-bg-${d.name}`)
              .transition()
              .attr("fill-opacity", 0.3)
              .style("stroke", "transparent")
          });

        let labelNodes = Object.values(this.topVillagerStarSignNodes);

        let labelG =  svgVillagerLabel.selectAll(".villager-label").data(labelNodes).join("g").classed('villager-label', true)

        labelG.append("text")
              .classed('villager-label-text', true)
              .text((d) => `${d.label}`)
              .style("text-anchor", "middle")
              .attr('x', d => d.x)
              .attr('y', d => d.y + radius*3.2);

        this.simulation.force('x', d3.forceX().x(d => d.ssX))
          .force('y', d3.forceY().y(d => d.ssY))
          .force('collide', d3.forceCollide().radius(radius+1).strength(0.8))
          .alpha(1).restart();

      }else{
        svgVillagerNode.style("stroke", 'none')
                       .style("fill", d => `url(#villager-thumbnail-${d.name})`)
                       .on("mouseenter", function(e,d) {
                         let thisCircle = d3.select(this);
                         let circleColor = skinColors.get(d.id);

                         /* calculate position */
                         let ePosition =  e.target.getBoundingClientRect(),
                             toolTipWidth = 200;

                         let lPosition = ePosition.left,
                             tPosition = ePosition.top;

                         let y =  window.scrollY + tPosition + radius*1.25;

                         let isPointRight = ((chartWidth - lPosition) <= toolTipWidth)?true:false;
                         let xPosition= lPosition + radius * 1.8;

                         let x = (isPointRight)?(xPosition - toolTipWidth - radius * 3.15):xPosition;

                         tooltipPhrase.attr("class", (isPointRight?'right':'left'))
                                     .transition()
                                     .duration(200)
                                     .style("display", "block")

                         tooltipPhrase.html(
                                         `<p>${greetings[d.personality]}, I'm <strong>${d.name}</strong>, <i>${d.phrase}</i>.</p>`
                                     )
                                     .style("transform",`none`)
                                     .style("top",`${y}px`)
                                     .style("left", `${x}px`);
                         thisCircle.raise()
                                   .transition()
                                   .duration(550)
                                   .style("fill", d => `url(#villager-thumbnail-${d.name})`)
                                   //.style("stroke", d => skinColors.get(d.id))
                                   .attr("r", radius*1.2);

                          d3.select(`#def-villager-bg-${d.name}`)
                             .transition()
                             .attr("fill-opacity", 0.8)
                             //.attr("fill", acnhColors.bgOrangeColor)
                             .style("stroke", acnhColors.borderYellowColor)
                             //.attr("transform", `scale(1) translate(0,0)`);

                       })
                       .on('mouseleave', function(e,d){
                           d3.select('#tooltip-phrase')
                                       .transition()
                                       .duration(200)
                                       .style("display", "none")

                           let thisCircle = d3.select(this);
                           thisCircle.lower()
                                     .transition()
                                     .duration(550)
                                     .style("fill", d => `url(#villager-thumbnail-${d.name})`)
                                     .style("stroke", 'none')
                                     .attr("r", radius);

                           d3.select(`#def-villager-bg-${d.name}`)
                              .transition()
                              .style("stroke", "transparent")
                              .attr("fill-opacity", 0.3)
                              .attr("fill", acnhColors.themeColor)

                         })

        let labelNodes = Object.values(this.topVillagerNodes);

        let labelG =  svgVillagerLabel.selectAll(".villager-label").data(labelNodes).join("g").classed('villager-label', true)

        labelG.append("text")
            .classed('villager-label-text', true)
            .text((d) => `${d.label}`)
            .style("text-anchor", "middle")
            .attr('x', d => d.x)
            .attr('y', d => (window.innerWidth <= mobileBreakpoint)?(d.y + radius*1.5):(d.y + radius*1.8));



       this.simulation.force('x', d3.forceX().x(d => d.defaultX))
         .force('y', d3.forceY().y(d => d.defaultY))
         .force('collide', d3.forceCollide().radius(radius+1).strength(0.8))
         .alpha(1).restart();
      }

     this.setState({ chartHeight: this.props.chartHeight})
     this.setState({ chartWidth: this.props.chartWidth})
   }

   flatten(arr) {
        return [].concat(...arr);
    }


  toggleChart(){
    this.setState(preState => ({ isChartOn: !preState.isChartOn }))
  }

  render() {
    const { chartWidth, chartHeight, isPhone, currentStep } = this.props
    const { isChartOn } = this.state
    //const { chartHeight } = this.state

    let hideChart = (isPhone === true && isChartOn === false)?true:false

    let forceStyles = {
    };

    return (
      <div style={forceStyles} id="force-chart">
        <div className="chart-toggle" style={{display:(isPhone && currentStep)?'block':'none'}}>
          <input type="checkbox" checked={(hideChart)} id='force-chart-toggle' name='force-chart-toggle' onChange={()=>this.toggleChart()}/>
          <label className={`chart-toggle-label ${hideChart?'open':'close'}`} htmlFor='force-chart-toggle' aria-label={hideChart?'See top 40 villagers':'Close'}> </label>
        </div>
        <div style={{display:(hideChart)?'none':'block'}}>
          <div className='ribbon-container'><div className='ribbon'><span className='ribbon-curve'>Top 40 Villagers</span></div></div>
          <svg ref={this.svgRef} width={chartWidth} height={chartHeight} ></svg>
        </div>
        <svg id="svg-patterns" width={0} height={0} style={{position:'absolute'}}></svg>
      </div>
    );

  }
}

export default TopVillagersChart;
